import {Link} from "react-router";
import {useContext, useEffect, useRef} from "react";
import ActivityContext, {IResolvedActivity} from "../contexts/Activity.tsx";

import GeneralContext from "../contexts/Gneral.tsx";
import {ReactSVG} from "react-svg";
import {calcItem} from "../helpers/calcItem.ts";
import html2canvas from "html2canvas";
import {jsPDF} from "jspdf";

export function FinalAvatar () {
    const  data  = useContext(GeneralContext);
    const {avatar,resolvedActivities,sendData} = useContext(ActivityContext);
    const contentRef = useRef<HTMLDivElement>(null);

    useEffect(() => {
        sendData();
    }, []);

    let _resolvedActivities = resolvedActivities.map( (item) => {
        return Object.assign({},calcItem(item));
        return item;
    }).sort((a,b)=> {
        return a.r > b.r ? 1 : -1;
    });

    const handleDownloadPdf = async () => {
        if (!contentRef.current) return;
        const el = contentRef.current;
        const parent = el.parentElement;
        const userDataEl = el.querySelector('.userData') as HTMLElement | null;

        // Save styles we'll temporarily modify
        const savedStyle = el.style.cssText;
        const savedParentStyle = parent ? parent.style.cssText : '';
        const savedUserDataStyle = userDataEl ? userDataEl.style.cssText : '';

        // Reveal overflow everywhere to measure true bounds.
        // .userData has overflow:auto on mobile which clips children.
        el.style.overflow = 'visible';
        if (parent) parent.style.overflow = 'visible';
        if (userDataEl) userDataEl.style.overflow = 'visible';

        const containerRect = el.getBoundingClientRect();
        const bounds = {
            left: containerRect.left,
            top: containerRect.top,
            right: containerRect.right,
            bottom: containerRect.bottom,
        };

        el.querySelectorAll('*').forEach(child => {
            if ((child as HTMLElement).closest('.avatar-halo')) return;
            const r = child.getBoundingClientRect();
            if (r.width === 0 && r.height === 0) return;
            bounds.left = Math.min(bounds.left, r.left);
            bounds.top = Math.min(bounds.top, r.top);
            bounds.right = Math.max(bounds.right, r.right);
            bounds.bottom = Math.max(bounds.bottom, r.bottom);
        });

        // Expand element so overflow fits inside its box.
        // Use a generous minimum horizontal padding (18% of width) because
        // html2canvas renders fonts/positioning slightly differently than the
        // browser, so measured overflow alone isn't enough.
        const pad = 20;
        const minPadH = Math.round(containerRect.width * 0.18);
        const padL = Math.max(minPadH, Math.max(0, containerRect.left - bounds.left) + pad);
        const padR = Math.max(minPadH, Math.max(0, bounds.right - containerRect.right) + pad);
        const padT = Math.max(0, containerRect.top - bounds.top) + pad;
        const padB = Math.max(0, bounds.bottom - containerRect.bottom) + pad;

        el.style.boxSizing = 'content-box';
        el.style.width = containerRect.width + 'px';
        el.style.height = containerRect.height + 'px';
        el.style.flexGrow = '0';
        el.style.flexShrink = '0';
        el.style.padding = `${padT}px ${padR}px ${padB}px ${padL}px`;

        // Start capture — reads dimensions and clones synchronously
        const canvasPromise = html2canvas(el, {
            useCORS: true,
            scale: 2,
            onclone: (_doc, clonedEl) => {
                // Remove overflow clipping on ALL descendants in the clone
                clonedEl.style.overflow = 'visible';
                if (clonedEl.parentElement) clonedEl.parentElement.style.overflow = 'visible';
                clonedEl.querySelectorAll('*').forEach(child => {
                    if (child instanceof HTMLElement) child.style.overflow = 'visible';
                });
                // Fill padding area with background color from nearest ancestor
                const win = _doc.defaultView;
                let bg = '';
                let anc: HTMLElement | null = clonedEl.parentElement;
                while (anc && win) {
                    const aBg = win.getComputedStyle(anc).backgroundColor;
                    if (aBg && aBg !== 'transparent' && aBg !== 'rgba(0, 0, 0, 0)') {
                        bg = aBg;
                        break;
                    }
                    anc = anc.parentElement;
                }
                clonedEl.style.backgroundColor = bg || '#ffffff';
            },
        });

        // Restore immediately — clone already captured the expanded state
        el.style.cssText = savedStyle;
        if (parent) parent.style.cssText = savedParentStyle;
        if (userDataEl) userDataEl.style.cssText = savedUserDataStyle;

        const canvas = await canvasPromise;
        const imgData = canvas.toDataURL('image/png');
        const imgWidth = canvas.width;
        const imgHeight = canvas.height;
        const pdf = new jsPDF({
            orientation: imgWidth > imgHeight ? 'landscape' : 'portrait',
            unit: 'px',
            format: [imgWidth, imgHeight],
        });
        pdf.addImage(imgData, 'PNG', 0, 0, imgWidth, imgHeight);
        pdf.save('my-avatar.pdf');
    };

    return (<div className={'final-screen ' + avatar?.color}>
        <div ref={contentRef} style={{flexGrow: 1, display: 'flex', flexDirection: 'column', overflow: 'hidden'}}>
            <h1>{data?.contents.finalAvatarScreenHeading3}<br />{data?.contents.finalAvatarScreenHeading2}<br />{data?.contents.finalAvatarScreenHeading1}</h1>
            <div className={"userData"}>
                <div className={"avatar-images-holder"}>
                    {avatar && <ReactSVG src={avatar.image} className={'avatar-image'} />}
                    {avatar && <ReactSVG src={avatar.image2} className={'avatar-image'} />}
                </div>
                {avatar && <ReactSVG src={avatar.halo} className={'avatar-halo'} />}
                {_resolvedActivities.map((item, index) =>{
                    return index > 4 ? '' : <div className={"title-row"}><strong key={index} className={'activity-title activity-'+(index+1)}>{item.activity.selectedSkill}</strong></div>
                })}
            </div>
        </div>
        <div className={"bottom-row"}>
            <h2>{data?.contents.finalAvatarScreenHeading4}</h2>
            <button className={'btn download'} onClick={handleDownloadPdf}>להורדת התוצר</button>
        </div>
    </div>);
}